<template>
  <div class="charts">
    <div class="select-searchmain1">
      <div class="earch-input">
        <div class="input-li2">
          <!-- <p>查询日期：</p> -->
          <el-date-picker
            size="small"
            style="width: 100%"
            v-model="dates"
            value-format="yyyy-MM"
            type="monthrange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </div>
        <div class="input-li">
          <!-- <p>选择辖区：</p> -->
          <el-select
            size="small"
            style="width: 100%"
            v-model="searchParams.jurisdiction"
            clearable
            placeholder="请选择辖区"
          >
            <el-option
              v-for="item in jurisdictions"
              :key="item.Key"
              :label="item.Value"
              :value="item.Key"
            >
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="search-action">
        <el-button
          size="small"
          icon="el-icon-search"
          type="primary"
          @click="getViews()"
          >查询</el-button
        >
        <!-- <el-button size="small" icon="el-icon-refresh" plain @click="onReset()">重置</el-button> -->
      </div>
    </div>
    <div class="chart-content">
      <div class="chart-card">
        <div class="chart-title">
          <div>危废数据</div>
          <el-radio-group
            v-model="chartType"
            @change="toogleChart"
            size="small"
          >
            <el-radio-button label="饼图"></el-radio-button>
            <el-radio-button label="折线图"></el-radio-button>
            <el-radio-button label="柱状图"></el-radio-button>
          </el-radio-group>
        </div>
        <div class="chart-main" id="danger-chart"></div>
      </div>
      <div class="chart-card">
        <div class="chart-title">
          <div>跨省处置地情况</div>
          <el-radio-group
            v-model="chartType2"
            @change="toogleChart2"
            size="small"
          >
            <el-radio-button label="饼图"></el-radio-button>
            <el-radio-button label="折线图"></el-radio-button>
            <el-radio-button label="柱状图"></el-radio-button>
          </el-radio-group>
        </div>
        <div class="chart-main" id="trans-chart"></div>
      </div>

      <div class="chart-card" style="width: 100%">
        <div class="chart-title">
          <div>处置方式</div>
          <el-radio-group
            v-model="chartType3"
            @change="toogleChart3"
            size="small"
          >
            <el-radio-button label="饼图"></el-radio-button>
            <el-radio-button label="折线图"></el-radio-button>
            <el-radio-button label="柱状图"></el-radio-button>
          </el-radio-group>
        </div>
        <div class="chart-main" id="handleType-chart"></div>
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from "echarts";

export default {
  data() {
    return {
      searchParams: {
        startDate: "",
        endDate: "",
        jurisdictions: null,
      },

      jurisdiction: [],
      manageCategory: [],
      industries: [],
      jurisdictions: [],
      chartType: "饼图",
      chartType2: "饼图",
      chartType3: "柱状图",
      dates: [],

      dangerPieData: [],
      dangerBarData: [],
      transPieData: [],
      transPlaces: [],
      transBarData: [],
      handleTypes: [],
      handleTypePieData: [],
      handleTypeBarData: [],
    };
  },
  methods: {
    toogleChart() {
      if (!document.getElementById("danger-chart")) return false;
      echarts.init(document.getElementById("danger-chart")).dispose();
      if (this.chartType == "饼图") {
        this.drawDangerPieCharts();
      } else {
        let chartType = this.chartType == "柱状图" ? "bar" : "line";
        this.drawDangerBarCharts(chartType);
      }
    },

    toogleChart2() {
      if (!document.getElementById("trans-chart")) return false;
      echarts.init(document.getElementById("trans-chart")).dispose();
      if (this.chartType2 == "饼图") {
        this.drawTransPieCharts();
      } else {
        var chartType = this.chartType2 == "柱状图" ? "bar" : "line";
        this.drawTransBarCharts(chartType);
      }
    },
    toogleChart3() {
      if (!document.getElementById("handleType-chart")) return false;
      echarts.init(document.getElementById("handleType-chart")).dispose();
      if (this.chartType3 == "饼图") {
        this.drawHandleTypePieCharts();
      } else {
        var chartType = this.chartType3 == "柱状图" ? "bar" : "line";
        this.drawHandleTypeBarCharts(chartType);
      }
    },

    getViews() {
      if (this.dates && this.dates.length > 0) {
        this.searchParams.startDate = this.dates[0];
        this.searchParams.endDate = this.dates[1];
      } else {
        this.searchParams.startDate = this.searchParams.endDate = null;
      }
      const params = {
        ...this.searchParams,
      };
      const url = this.$api.statistics.getDangerDataView;
      this.$axios.get(url, params, false).then((res) => {
        if (res.data.code == 0) {
          let {
            dangerPieData,
            dangerBarData,
            transPieData,
            transBarData,
            transPlaces,
            handleTypes,
            handleTypePieData,
            handleTypeBarData,
            jurisdictions,
          } = res.data.data;

          if (this.jurisdictions.length <= 0)
            this.jurisdictions = jurisdictions;

          this.transPlaces = transPlaces;
          this.handleTypes = handleTypes;
          this.dangerPieData = dangerPieData;
          this.dangerBarData = dangerBarData;
          this.transPieData = transPieData;
          this.transBarData = transBarData;
          this.handleTypePieData = handleTypePieData;
          this.handleTypeBarData = handleTypeBarData;

          this.toogleChart();
          this.toogleChart2();
          this.toogleChart3();
        } else {
          this.$message({
            message: "加载数据失败，请重试",
            type: "error",
          });
        }
      });
    },

    drawDangerPieCharts() {
      let pieData = Object.entries(this.dangerPieData).map(([name, value]) => ({
        name,
        value,
      }));
      let option = {
        tooltip: {
          trigger: "item",
          // formatter: function (params) {

          //   // 获取数据
          //   const data = pieData[params.dataIndex];
          //   let jurisdictions = data.jurisdictions;
          //   if (jurisdictions == null) return ""
          //   let thColor = '#fff'
          //   if (params.name == '简化管理') {
          //     thColor = "#808080"
          //   }
          //   // 构建tooltip内容
          //   let tooltipContent = '<div> <table style="text-align:center;border-collapse: collapse;">'; // 设置表格边框折叠
          //   tooltipContent += '<tr style="background-color:' + params.color + ';color:' + thColor + '">'
          //   tooltipContent += '<th style="border: 1px solid ' + params.color + '; padding: 5px;">辖区</th>'; // 设置表头边框和内边距
          //   tooltipContent += '<th style="border: 1px solid ' + params.color + '; padding: 5px;">数量（家）</th>'; // 设置表头边框和内边距
          //   tooltipContent += '</tr>';
          //   jurisdictions.forEach(function (jurisdiction) {
          //     tooltipContent += '<tr>';
          //     tooltipContent += `<td style="border: 1px solid ${params.color}; padding: 5px;">${jurisdiction.jurisdiction}</td>`; // 设置单元格边框和内边距
          //     tooltipContent += `<td style="border: 1px solid ${params.color}; padding: 5px;">${jurisdiction.count}</td>`; // 设置单元格边框和内边距
          //     tooltipContent += '</tr>';
          //   });
          //   tooltipContent += '</table></div>';
          //   let title = `<div style="margin-bottom:7px"> ${params.marker}  ${data.name} : ${data.value} 家 </div> `
          //   return `${title}  ${tooltipContent}`;
          // }
        },
        legend: {
          top: "center",
          right: "5%",

          orient: "vertical",
        },
        graphic: {
          type: "text", // 类型：文本
          left: "center",
          top: "middle",
          silent: true, // 不响应事件
          invisible: pieData.length > 0, // 有数据就隐藏
          style: {
            fill: "#9d9d9d",
            fontWeight: "bold",
            text: "暂无数据",
            fontFamily: "Microsoft YaHei",
            fontSize: "25px",
          },
        },
        series: [
          {
            type: "pie",
            radius: ["35%", "55%"],
            avoidLabelOverlap: true,
            label: {
              show: true,
              normal: {
                formatter: "{b}\n \n \t{c} 吨",
                textStyle: {
                  fontSize: 14,
                },
              },
            },
            emphasis: {
              label: {
                show: true,
                fontSize: 16,
                fontWeight: "bold",
              },
            },
            labelLine: {
              show: true,
              // length2: 50,
              // length: 20,
              // lineStyle: {
              //   color: '#000'
              // }
            },
            data: pieData,
          },
        ],
      };
      const myChart = echarts.init(document.getElementById("danger-chart"));
      myChart.setOption(option);
      window.addEventListener("resize", () => {
        myChart.resize();
      });
    },

    drawDangerBarCharts(chartType) {
      const data = this.dangerBarData;
      let option = {
        // title: {
        //   text: '危废数据'
        // },
        graphic: {
          type: "text", // 类型：文本
          left: "center",
          top: "middle",
          silent: true, // 不响应事件
          invisible: data.length > 0, // 有数据就隐藏
          style: {
            fill: "#9d9d9d",
            fontWeight: "bold",
            text: "暂无数据",
            fontFamily: "Microsoft YaHei",
            fontSize: "25px",
          },
        },
        legend: {},
        // toolbox: {
        //   feature: {
        //     // dataView: { show: true, readOnly: false },
        //     magicType: {
        //       //动态类型切换
        //       show: true, //是否显示该工具
        //       type: ["line", "bar", "stack"], //启用的动态类型
        //       title: {
        //         line: "切换为折线图",
        //         bar: "切换为柱状图",
        //         stack: "切换为堆叠",
        //       },
        //     },
        //     restore: { show: true, title: "还原" },
        //     // saveAsImage: { show: true }
        //   },
        // },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            crossStyle: {
              color: "#999",
            },
          },
          // formatter: function (params) {
          //   var jurisdictions = params.data[params.seriesName + '辖区']

          //   if (jurisdictions == null) {
          //     return ''
          //   }
          //   let thColor = '#fff'
          //   let color = params.color
          //   let title = "<div style='margin-bottom:5px'>"

          //   title += `<div>${params.marker} ${params.seriesName}：${params.value[params.seriesName]} 家 </div>`;

          //   title += "</div>"

          //   // 构建tooltip内容
          //   let tooltipContent = '<div style=""> <table style="text-align:center;border-collapse: collapse;">'; // 设置表格边框折叠
          //   tooltipContent += '<tr style="background-color:' + color + ';color:' + thColor + '">'
          //   tooltipContent += '<th style="border: 1px solid ' + color + '; padding: 5px 10px;">辖区</th>';

          //   // 设置表头边框和内边距
          //   tooltipContent += '<th style="border: 1px solid ' + color + '; padding: 5px 10px;">个数（家）</th>'; // 设置表头边框和内边距

          //   tooltipContent += '</tr>';
          //   jurisdictions.forEach((jurisdiction) => {
          //     tooltipContent += '<tr>';
          //     tooltipContent += `<td style="border: 1px solid ${color}; padding: 5px 10px;">${jurisdiction.jurisdiction}</td>`; // 设置单元格边框和内边距
          //     tooltipContent += `<td style="border: 1px solid ${color}; padding: 5px 10px;">${jurisdiction.count} </td>`; // 设置单元格边框和内边距

          //     tooltipContent += '</tr>';
          //   });
          //   tooltipContent += '</table></div>';

          //   return `<div> ${title} ${tooltipContent}</div>`;
          // }
        },
        dataset: {
          dimensions: ["date", "产生量", "处置量", "贮存量"],
          source: data,
        },
        xAxis: {
          type: "category",
          splitLine: {
            show: false,
          },
          axisPointer: {
            type: "shadow",
          },
          axisLabel: {
            show: true,

            rotate: 40,
          },
        },
        yAxis: {
          type: "value",
          axisLabel: {
            formatter: "{value} 吨",
          },
          splitLine: {
            show: false,
          },
        },
        series: [
          {
            type: chartType,
            smooth: true,
          },
          {
            type: chartType,
            smooth: true,
          },
          {
            type: chartType,
            smooth: true,
          },
        ],
      };
      const myChart = echarts.init(document.getElementById("danger-chart"));
      myChart.setOption(option);
      window.addEventListener("resize", () => {
        myChart.resize();
      });
    },

    drawTransPieCharts() {
      let pieData = this.transPieData;
      let option = {
        tooltip: {
          trigger: "item",
          // formatter: function (params) {

          //   // 获取数据
          //   const data = pieData[params.dataIndex];
          //   let jurisdictions = data.jurisdictions;
          //   if (jurisdictions == null) return ""
          //   let thColor = '#fff'
          //   if (params.name == '简化管理') {
          //     thColor = "#808080"
          //   }
          //   // 构建tooltip内容
          //   let tooltipContent = '<div> <table style="text-align:center;border-collapse: collapse;">'; // 设置表格边框折叠
          //   tooltipContent += '<tr style="background-color:' + params.color + ';color:' + thColor + '">'
          //   tooltipContent += '<th style="border: 1px solid ' + params.color + '; padding: 5px;">辖区</th>'; // 设置表头边框和内边距
          //   tooltipContent += '<th style="border: 1px solid ' + params.color + '; padding: 5px;">数量（家）</th>'; // 设置表头边框和内边距
          //   tooltipContent += '</tr>';
          //   jurisdictions.forEach(function (jurisdiction) {
          //     tooltipContent += '<tr>';
          //     tooltipContent += `<td style="border: 1px solid ${params.color}; padding: 5px;">${jurisdiction.jurisdiction}</td>`; // 设置单元格边框和内边距
          //     tooltipContent += `<td style="border: 1px solid ${params.color}; padding: 5px;">${jurisdiction.count}</td>`; // 设置单元格边框和内边距
          //     tooltipContent += '</tr>';
          //   });
          //   tooltipContent += '</table></div>';
          //   let title = `<div style="margin-bottom:7px"> ${params.marker}  ${data.name} : ${data.value} 家 </div> `
          //   return `${title}  ${tooltipContent}`;
          // }
        },
        legend: {
          top: "center",
          right: "5%",

          orient: "vertical",
        },
        graphic: {
          type: "text", // 类型：文本
          left: "center",
          top: "middle",
          silent: true, // 不响应事件
          invisible: pieData.length > 0, // 有数据就隐藏
          style: {
            fill: "#9d9d9d",
            fontWeight: "bold",
            text: "暂无数据",
            fontFamily: "Microsoft YaHei",
            fontSize: "25px",
          },
        },
        series: [
          {
            type: "pie",
            radius: ["35%", "55%"],
            avoidLabelOverlap: true,
            label: {
              show: true,
              normal: {
                formatter: "{b}\n \n \t{c} 吨",
                textStyle: {
                  fontSize: 14,
                },
              },
            },
            emphasis: {
              label: {
                show: true,
                fontSize: 16,
                fontWeight: "bold",
              },
            },
            labelLine: {
              show: true,
              // length2: 50,
              // length: 20,
              // lineStyle: {
              //   color: '#000'
              // }
            },
            data: pieData,
          },
        ],
      };
      const myChart = echarts.init(document.getElementById("trans-chart"));
      myChart.setOption(option);
      window.addEventListener("resize", () => {
        myChart.resize();
      });
    },

    drawTransBarCharts(chartType) {
      const convertedData = [];
      this.transBarData.forEach((obj) => {
        const convertedObj = { date: obj.date };

        this.transPlaces.forEach((key) => {
          //值可能会为undefined，可以把undefined变成0吗
          convertedObj[key] =
            obj.value.find((item) => item.key == key)?.value || 0;
        });
        convertedData.push(convertedObj);
      });
      console.log(["date", ...this.transPlaces]);

      const data = convertedData;
      const series = [];
      for (let index = 0; index < this.transPlaces.length; index++) {
        series.push({
          type: chartType,
          smooth: true,
        });
      }

      const dimensions = ["date", ...this.transPlaces];

      let option = {
        // title: {
        //   text: '危废数据'
        // },
        graphic: {
          type: "text", // 类型：文本
          left: "center",
          top: "middle",
          silent: true, // 不响应事件
          invisible: data.length > 0, // 有数据就隐藏
          style: {
            fill: "#9d9d9d",
            fontWeight: "bold",
            text: "暂无数据",
            fontFamily: "Microsoft YaHei",
            fontSize: "25px",
          },
        },
        legend: {},
        // toolbox: {
        //   feature: {
        //     // dataView: { show: true, readOnly: false },
        //     magicType: {
        //       //动态类型切换
        //       show: true, //是否显示该工具
        //       type: ["line", "bar", "stack"], //启用的动态类型
        //       title: {
        //         line: "切换为折线图",
        //         bar: "切换为柱状图",
        //         stack: "切换为堆叠",
        //       },
        //     },
        //     restore: { show: true, title: "还原" },
        //     // saveAsImage: { show: true }
        //   },
        // },
        tooltip: {
          trigger: "axis",
          // axisPointer: {
          //   type: 'cross',
          //   crossStyle: {
          //     color: '#999'
          //   }
          // },
          // formatter: function (params) {
          //   var jurisdictions = params.data[params.seriesName + '辖区']

          //   if (jurisdictions == null) {
          //     return ''
          //   }
          //   let thColor = '#fff'
          //   let color = params.color
          //   let title = "<div style='margin-bottom:5px'>"

          //   title += `<div>${params.marker} ${params.seriesName}：${params.value[params.seriesName]} 家 </div>`;

          //   title += "</div>"

          //   // 构建tooltip内容
          //   let tooltipContent = '<div style=""> <table style="text-align:center;border-collapse: collapse;">'; // 设置表格边框折叠
          //   tooltipContent += '<tr style="background-color:' + color + ';color:' + thColor + '">'
          //   tooltipContent += '<th style="border: 1px solid ' + color + '; padding: 5px 10px;">辖区</th>';

          //   // 设置表头边框和内边距
          //   tooltipContent += '<th style="border: 1px solid ' + color + '; padding: 5px 10px;">个数（家）</th>'; // 设置表头边框和内边距

          //   tooltipContent += '</tr>';
          //   jurisdictions.forEach((jurisdiction) => {
          //     tooltipContent += '<tr>';
          //     tooltipContent += `<td style="border: 1px solid ${color}; padding: 5px 10px;">${jurisdiction.jurisdiction}</td>`; // 设置单元格边框和内边距
          //     tooltipContent += `<td style="border: 1px solid ${color}; padding: 5px 10px;">${jurisdiction.count} </td>`; // 设置单元格边框和内边距

          //     tooltipContent += '</tr>';
          //   });
          //   tooltipContent += '</table></div>';

          //   return `<div> ${title} ${tooltipContent}</div>`;
          // }
        },
        dataset: {
          dimensions,
          source: convertedData,
        },
        xAxis: {
          type: "category",
          splitLine: {
            show: false,
          },
          axisPointer: {
            type: "shadow",
          },
          axisLabel: {
            show: true,
            rotate: 40,
          },
        },
        yAxis: {
          type: "value",
          axisLabel: {
            formatter: "{value} 吨",
          },
          splitLine: {
            show: false,
          },
        },
        series: series,
      };
      const myChart = echarts.init(document.getElementById("trans-chart"));
      myChart.setOption(option);
      window.addEventListener("resize", () => {
        myChart.resize();
      });
    },
    drawHandleTypePieCharts() {
      let pieData = this.handleTypePieData;
      let option = {
        tooltip: {
          trigger: "item",
          // formatter: function (params) {

          //   // 获取数据
          //   const data = pieData[params.dataIndex];
          //   let jurisdictions = data.jurisdictions;
          //   if (jurisdictions == null) return ""
          //   let thColor = '#fff'
          //   if (params.name == '简化管理') {
          //     thColor = "#808080"
          //   }
          //   // 构建tooltip内容
          //   let tooltipContent = '<div> <table style="text-align:center;border-collapse: collapse;">'; // 设置表格边框折叠
          //   tooltipContent += '<tr style="background-color:' + params.color + ';color:' + thColor + '">'
          //   tooltipContent += '<th style="border: 1px solid ' + params.color + '; padding: 5px;">辖区</th>'; // 设置表头边框和内边距
          //   tooltipContent += '<th style="border: 1px solid ' + params.color + '; padding: 5px;">数量（家）</th>'; // 设置表头边框和内边距
          //   tooltipContent += '</tr>';
          //   jurisdictions.forEach(function (jurisdiction) {
          //     tooltipContent += '<tr>';
          //     tooltipContent += `<td style="border: 1px solid ${params.color}; padding: 5px;">${jurisdiction.jurisdiction}</td>`; // 设置单元格边框和内边距
          //     tooltipContent += `<td style="border: 1px solid ${params.color}; padding: 5px;">${jurisdiction.count}</td>`; // 设置单元格边框和内边距
          //     tooltipContent += '</tr>';
          //   });
          //   tooltipContent += '</table></div>';
          //   let title = `<div style="margin-bottom:7px"> ${params.marker}  ${data.name} : ${data.value} 家 </div> `
          //   return `${title}  ${tooltipContent}`;
          // }
        },
        legend: {
          top: "center",
          right: "5%",

          orient: "vertical",
        },
        graphic: {
          type: "text", // 类型：文本
          left: "center",
          top: "middle",
          silent: true, // 不响应事件
          invisible: pieData.length > 0, // 有数据就隐藏
          style: {
            fill: "#9d9d9d",
            fontWeight: "bold",
            text: "暂无数据",
            fontFamily: "Microsoft YaHei",
            fontSize: "25px",
          },
        },
        series: [
          {
            type: "pie",
            radius: ["35%", "55%"],
            avoidLabelOverlap: true,
            label: {
              show: true,
              normal: {
                formatter: "{b}\n \n \t{c} 吨",
                textStyle: {
                  fontSize: 14,
                },
              },
            },
            emphasis: {
              label: {
                show: true,
                fontSize: 16,
                fontWeight: "bold",
              },
            },
            labelLine: {
              show: true,
              showAbove: true,
              // length2: 50,
              // length: 60,
              // lineStyle: {
              //   color: '#000'
              // }
            },
            data: pieData,
          },
        ],
      };
      const myChart = echarts.init(document.getElementById("handleType-chart"));
      myChart.setOption(option);
      window.addEventListener("resize", () => {
        myChart.resize();
      });
    },

    drawHandleTypeBarCharts(chartType) {
      const convertedData = [];
      this.handleTypeBarData.forEach((obj) => {
        const convertedObj = { date: obj.date };

        this.handleTypes.forEach((key) => {
          //值可能会为undefined，可以把undefined变成0吗
          convertedObj[key] =
            obj.value.find((item) => item.key == key)?.value || 0;
        });
        convertedData.push(convertedObj);
      });

      const data = convertedData;
      const series = [];
      for (let index = 0; index < this.handleTypes.length; index++) {
        series.push({
          type: chartType,
          smooth: true,
        });
      }

      const dimensions = ["date", ...this.handleTypes];

      let option = {
        // title: {
        //   text: '危废数据'
        // },
        graphic: {
          type: "text", // 类型：文本
          left: "center",
          top: "middle",
          silent: true, // 不响应事件
          invisible: data.length > 0, // 有数据就隐藏
          style: {
            fill: "#9d9d9d",
            fontWeight: "bold",
            text: "暂无数据",
            fontFamily: "Microsoft YaHei",
            fontSize: "25px",
          },
        },
        legend: {},
        // toolbox: {
        //   feature: {
        //     // dataView: { show: true, readOnly: false },
        //     magicType: {
        //       //动态类型切换
        //       show: true, //是否显示该工具
        //       type: ["line", "bar", "stack"], //启用的动态类型
        //       title: {
        //         line: "切换为折线图",
        //         bar: "切换为柱状图",
        //         stack: "切换为堆叠",
        //       },
        //     },
        //     restore: { show: true, title: "还原" },
        //     // saveAsImage: { show: true }
        //   },
        // },
        tooltip: {
          trigger: "axis",
          // axisPointer: {
          //   type: 'cross',
          //   crossStyle: {
          //     color: '#999'
          //   }
          // },
          // formatter: function (params) {
          //   var jurisdictions = params.data[params.seriesName + '辖区']

          //   if (jurisdictions == null) {
          //     return ''
          //   }
          //   let thColor = '#fff'
          //   let color = params.color
          //   let title = "<div style='margin-bottom:5px'>"

          //   title += `<div>${params.marker} ${params.seriesName}：${params.value[params.seriesName]} 家 </div>`;

          //   title += "</div>"

          //   // 构建tooltip内容
          //   let tooltipContent = '<div style=""> <table style="text-align:center;border-collapse: collapse;">'; // 设置表格边框折叠
          //   tooltipContent += '<tr style="background-color:' + color + ';color:' + thColor + '">'
          //   tooltipContent += '<th style="border: 1px solid ' + color + '; padding: 5px 10px;">辖区</th>';

          //   // 设置表头边框和内边距
          //   tooltipContent += '<th style="border: 1px solid ' + color + '; padding: 5px 10px;">个数（家）</th>'; // 设置表头边框和内边距

          //   tooltipContent += '</tr>';
          //   jurisdictions.forEach((jurisdiction) => {
          //     tooltipContent += '<tr>';
          //     tooltipContent += `<td style="border: 1px solid ${color}; padding: 5px 10px;">${jurisdiction.jurisdiction}</td>`; // 设置单元格边框和内边距
          //     tooltipContent += `<td style="border: 1px solid ${color}; padding: 5px 10px;">${jurisdiction.count} </td>`; // 设置单元格边框和内边距

          //     tooltipContent += '</tr>';
          //   });
          //   tooltipContent += '</table></div>';

          //   return `<div> ${title} ${tooltipContent}</div>`;
          // }
        },
        dataset: {
          dimensions,
          source: convertedData,
        },
        xAxis: {
          type: "category",
          splitLine: {
            show: false,
          },
          axisPointer: {
            type: "shadow",
          },
          axisLabel: {
            show: true,
            // rotate: 40,
          },
        },
        yAxis: {
          type: "value",
          axisLabel: {
            formatter: "{value} 吨",
          },
          splitLine: {
            show: false,
          },
        },
        series: series,
      };
      const myChart = echarts.init(document.getElementById("handleType-chart"));
      myChart.setOption(option);
      window.addEventListener("resize", () => {
        myChart.resize();
      });
    },
  },

  mounted() {
    // 获取当前年份和月份
    const currentMonth = this.$dayjs().format("YYYY-MM");
    // 获取上个月的年份和月份
    const lastMonth = this.$dayjs().subtract(1, "month").format("YYYY-MM");
    this.dates.push(lastMonth, currentMonth);
    this.getViews();
  },
};
</script>

<style lang="scss" scoped>
.charts {
  height: 100%;
}

.chart-content {
  display: flex;
  flex-wrap: wrap;
  height: calc(100% - 60px);

  .chart-card {
    border: 1px solid #909399;
    width: 48%;
    margin: 10px 1%;
    height: calc(50% - 30px);
    border-radius: 3px;

    .chart-title {
      width: 100%;

      height: 45px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      border-bottom: 1px solid #909399;
      padding: 0px 10px;
    }

    .chart-main {
      width: 100%;
      height: calc(100% - 45px);
    }
  }
}

.select-searchmain1 {
  width: 100%;
  height: 50px;
  display: flex;
  padding: 5px;
  box-sizing: content-box;

  .search-action {
    display: inline-block;
    // width: 230px;
    text-align: center;
    height: 100%;
    margin-right: 10px;
    // line-height: 70px;
  }

  .earch-input {
    flex-grow: 1;
    padding-left: 20px;

    p {
      width: 100%;
      height: 30px;
      line-height: 30px;
    }

    .input-li2 {
      margin-right: 20px;
      width: 350px;
      font-size: 12px;
      display: inline-block;

      .el-input {
        line-height: 40px;
      }
    }

    .input-li {
      margin-right: 20px;
      width: 200px;
      font-size: 12px;
      display: inline-block;

      .el-input {
        line-height: 40px;
      }
    }
  }
}
</style>
